import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=638bb69c"
import script from "./doctor.vue?vue&type=script&lang=ts"
export * from "./doctor.vue?vue&type=script&lang=ts"
import style0 from "./doctor.vue?vue&type=style&index=0&id=638bb69c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports